import { FC, ReactElement } from 'react'

export const ComingSoon: FC = (): ReactElement => (
  <div className="sectionHb-block dashboardHb">
    <div className="sectionHb-block__wrap">
      <h2 className="sectionHb-title">Coming soon, promise!</h2>
      <div className="dashboardHb-img">
        <img src="/account/img/video/dashboard.svg" alt="" />
      </div>
      <p>
        <b>Stay tuned;</b> we&apos;ll notify you as soon as this function is ready.
      </p>
      <br />
      <p>
        <button className="primary-btn" type="button">
          Buzz me when available
        </button>
      </p>
    </div>
  </div>
)
